precision highp float;

uniform vec2 cell_size;
uniform vec2 mouse;
uniform vec2 offset;
uniform vec2 radius;
uniform float radiusIncrease;
uniform vec3 resolution;
uniform float stroke_width;
uniform vec3 stroke;
uniform float time;
uniform float mouseDown;
uniform float pulseTime;
uniform float noiseDensity;
uniform float noiseBrightness;
#pragma glslify: snoise3 = require('glsl-noise/simplex/3d')

float rand(vec2 co){
  return fract(sin(dot(co.xy, vec2(12.9898,78.233))) * 43758.5453);
}

float isGrid(float pos, float size, float stroke_width) {
  return step(fract(pos / size), stroke_width / size);
}

float n1rand( vec2 n, float time )
{
  float t = mod(floor(time * 30.0), 30.0);
  // float t = fract( time );
  float nrnd0 = rand( n + 0.07 * t );
  return nrnd0;
}

float n4rand( vec2 n, float time)
{
  float t = fract( time );
  float nrnd0 = rand( n + 0.07*t );
  float nrnd1 = rand( n + 0.11*t );
  float nrnd2 = rand( n + 0.13*t );
  float nrnd3 = rand( n + 0.17*t );
  return (nrnd0 + nrnd1 + nrnd2 + nrnd3) / 4.0;
}

float n8rand( vec2 n, float time )
{
  float t = fract( time );
  float nrnd0 = rand( n + 0.07*t );
  float nrnd1 = rand( n + 0.11*t );  
  float nrnd2 = rand( n + 0.13*t );
  float nrnd3 = rand( n + 0.17*t );
  float nrnd4 = rand( n + 0.19*t );
  float nrnd5 = rand( n + 0.23*t );
  float nrnd6 = rand( n + 0.29*t );
  float nrnd7 = rand( n + 0.31*t );
  
  return (nrnd0+nrnd1+nrnd2+nrnd3 +nrnd4+nrnd5+nrnd6+nrnd7) / 8.0;
}

//alternative Gaussian,
//thanks to @self_shadow
//see http://www.dspguide.com/ch2/6.htm
float n4rand_ss( vec2 n, float time )
{
  float nrnd0 = rand( n + 0.07*fract( time ) );
  float nrnd1 = rand( n + 0.11*fract( time + 0.573953 ) );  
  return 0.23*sqrt(-log(nrnd0+0.00001))*cos(2.0*3.141592*nrnd1)+0.5;
}

void main() {
  vec2 uv = gl_FragCoord.xy / resolution.xy;
  uv.y = 1.0 - uv.y;
  uv.x *= (resolution.x / resolution.y);
  // uv += uv * cos(sin(time) * 5.0 * length(uv)) * 0.2 * mouseDown;

  /* GRID */
  vec2 fCoord = vec2(uv.x * resolution.y, uv.y * resolution.y) + offset;
  // Black if not on a grildine or 'stroke' color set in index.js if we are on the gridline
  vec3 isGridline = mix(vec3(0), stroke, vec3(max(
    isGrid(fCoord.x, cell_size.x, stroke_width),
    isGrid(fCoord.y, cell_size.y, stroke_width)
  )));

  // Mask Circle
  float r = radius[0] + sin(pulseTime) * radius[1] + mouseDown * radiusIncrease;
  float d = min(distance(mouse, gl_FragCoord.xy), r) / r;

  // Starter Noise
  // float noise_multiplier = n8rand(gl_FragCoord.xy / resolution.xy, time);
  float noise_multiplier;

  vec2 uv2 = gl_FragCoord.xy / resolution.xy;
  float n = snoise3(vec3(uv2 * 5000.0, time * 0.15 * 5.0));
  n += snoise3(vec3(uv2 * 1500.0 + vec2(0.11, -0.75), time * 0.5 * 5.0));
  n += snoise3(vec3(uv2 * 7000.0 + vec2(-0.23, 0.35), time * -0.25 * 5.0));
  n += snoise3(vec3(uv2 * 15000.0 + vec2(-0.43, 0.85), time * 0.15 * 5.0));
  noise_multiplier = n;


  vec3 c = vec3(1);
  vec3 outerColor = vec3(step(noise_multiplier, noiseDensity) * noise_multiplier);
  vec3 innerColor = vec3(step(noise_multiplier, noiseBrightness) * noise_multiplier);
  innerColor = abs(innerColor - vec3(1.0 - d));
  c = mix(outerColor, innerColor * 1.05, 1.0 - d);

  // Multiply with the grid
  c = c * isGridline;
  gl_FragColor = vec4(c, 1.0);
  return;
}